import {ELOTypeEnum} from '../../../../../../../shared/GameEnums'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {MatchmakingPriority} from '../../../../../../../shared/matchmaking/MatchmakingEnums'
import {MatchmakingPreferences, MatchmakingRequest} from '../../../../../../../shared/matchmaking/MatchmakingInterfaces'
import {FindGameRankedState} from '../../../../../../../shared/ranked/ranked_user_state_data/FindGameRankedState'
import {RankedUserStateController} from '@colonist/leaderboard-types'
import {UIAjaxWrapper} from '../../../../../../shared/scripts/network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../../../../../../shared/scripts/network/UIAPIEndpoints'
import {SocketMatchmakingSend} from '../../../../../../shared/scripts/socket/SocketMatchmakingSend'
import {GameTypeEnum} from './matchmaking_selection/UIMMatchmakingController'
import {COLONIST_VERSION} from '@colonist/types'

export class UIMMatchmakingActionsController {
    private rankedStateGameMode: GameTypeEnum
    private findGameRankedStates: FindGameRankedState[] = []

    constructor() {
        void this.fetchRankedState()
    }

    // eslint-disable-next-line class-methods-use-this
    sendFindGameMessageToServer(selectedMatchTypes: MatchmakingMatchTypes[]) {
        const matchmakingRequest: MatchmakingRequest = {
            matchPreferences: [],
            adblockEnabled: false,
            clientVersion: COLONIST_VERSION,
        }

        for(const type of selectedMatchTypes) {
            const preference: MatchmakingPreferences = {
                matchType: type,
                priority: MatchmakingPriority.High,
            }
            matchmakingRequest.matchPreferences.push(preference)
        }

        SocketMatchmakingSend.enterMatchmaker(matchmakingRequest)
    }

    async fetchRankedState() {
        const displayError = false
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiFindGameState(), undefined, undefined, displayError)
        if(response == undefined) return
        if(response.isSuccess == false) return
        this.findGameRankedStates = response.json as FindGameRankedState[]
    }

    private getEloFromRankedGame() {
        const gameMode = this.rankedStateGameMode
        if(gameMode == GameTypeEnum.Classic1v1) return ELOTypeEnum.VisibleRanked1v1
        if(gameMode == GameTypeEnum.Classic4P) return ELOTypeEnum.VisibleRanked4PClassic
        if(gameMode == GameTypeEnum.CitiesAndKnights4P) return ELOTypeEnum.VisibleRankedCitiesAndKnights4P
        return ELOTypeEnum.Inactive
    }

    getRankedState() {
        const eloType = this.getEloFromRankedGame()
        const gameType = this.findGameRankedStates.find((rankedGameState: FindGameRankedState) => {
            if(!rankedGameState.active) return false
            if(rankedGameState.eloType != eloType) return false
            return true
        })

        if(!gameType?.rankedState) return

        return RankedUserStateController.deserialize(gameType.rankedState)
    }

    getRankedPlacementText(gameMode: GameTypeEnum) {
        this.rankedStateGameMode = gameMode
        const rankedState = this.getRankedState()
        if(!rankedState) return
        return rankedState.getFindGamePopupStatusText()
    }
}
